import serviceDealerCreator from './creators/serviceDealerCreator';
import { pageNames } from '@atc/bonnet-paths';

export default serviceDealerCreator({
    namespace: pageNames.DEALER_DETAILS,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
    initialState: {},
});
